// export const baseURL = process.env.REACT_APP_BASE_URL || "/api/v1";
// This checks for a build-time variable, otherwise it stays on the same domain
export const baseURL = process.env.REACT_APP_BASE_URL || "/api/v1";
// export const baseURL = "https://lbanblogapi-fwbgd0e8fraragd2.westeurope-01.azurewebsites.net/api/v1";